import iro from "@jaames/iro";

export const setColor = function (el) {
    document.body.classList.add("enable-colorpicker");
};
export const disableColorPopup = function (el) {
    document.body.classList.remove("enable-colorpicker");
};
let colorPickerElement;
let currentColor;
export const colorPicker = function (el) {
    const color = el.getAttribute("data-color");
    colorPickerElement = new iro.ColorPicker(el, {
        width: 300,
        color: color,
        borderWidth: 0,
        borderColor: "#fff",
        layout: [
            {
                component: iro.ui.Box,
            },
            {
                component: iro.ui.Slider,
                options: {
                    id: "hue-slider",
                    sliderType: "hue",
                },
            },
        ],
    });
    const colorChangeCallback = function (color) {
        console.log(color);
        document.body.classList.add("color-manipulated");
        document.documentElement.style.setProperty("--yellow", color.hexString);
        currentColor = color.hexString;
        document.querySelector('[data-handler="setColor"]').innerText = color.hexString
    };
    colorPickerElement.on("color:change", colorChangeCallback);
};

export const submitColor = function (el) {
    if (document.body.classList.contains("color-manipulated")) {
        const request = new XMLHttpRequest();
        request.open("POST", window.vars.ajax_url, true);
        request.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded; charset=UTF-8"
        );
        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                var resp = this.response;
            }
        };
        const color = currentColor;
        request.send(
            "color=" +
            color +
            "&action=save_color&security=" +
            window.vars["security"]
        );

        document.body.classList.remove("enable-colorpicker");
    }
};
